import { render, staticRenderFns } from "./AnonNetCustomerForm.vue?vue&type=template&id=4a84b968"
import script from "./AnonNetCustomerForm.vue?vue&type=script&lang=ts"
export * from "./AnonNetCustomerForm.vue?vue&type=script&lang=ts"
import style0 from "./AnonNetCustomerForm.vue?vue&type=style&index=0&id=4a84b968&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports